import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer p-10 bg-light mt-6 text-base-content">
            <div>
                <img className='h-16' src="https://booksrun.com/images/green-promise-book.svg" alt="" />
                <p>Book Bazer<br />Providing since 2010 .</p>
            </div>
            <div>
                <span className="footer-title">Services</span>
                <Link className="link link-hover">Selling</Link>
                <Link className="link link-hover">Buying</Link>
                <Link className="link link-hover">Payment</Link>
                <Link className="link link-hover">Hotline</Link>
            </div>
            <div>
                <span className="footer-title">Company</span>
                <Link className="link link-hover">About us</Link>
                <Link className="link link-hover">Contact</Link>
                <Link className="link link-hover">Jobs</Link>

            </div>
            <div>
                <span className="footer-title">Address</span>
                <Link className="link link-hover">IIUM , Gombak</Link>
                <Link className="link link-hover">Selangor - 53100</Link>

            </div>
        </footer>
    );
};

export default Footer;